/** Formatação pt-BR do descritivo, alinhada ao legado: #.##0,00 e dd/MM/aaaa. */

export const fmtHoras = (n: number): string =>
  n.toLocaleString("pt-BR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

/** A data chega como "aaaa-MM-dd..."; reformata pelo prefixo para não deslizar de fuso. */
export const fmtData = (iso: string): string => {
  const [ano, mes, dia] = iso.slice(0, 10).split("-");
  return `${dia}/${mes}/${ano}`;
};

const ABREV = ["", "Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"];
export const labelMes = (mes: number, ano: number): string =>
  `${ABREV[mes]}/${String(ano).slice(2)}`;

const MESES = ["", "Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho",
  "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"];
export const nomeMes = (mes: number): string => MESES[mes];

/** Primeiro e último dia do mês, no formato aaaa-MM-dd. */
export const limitesDoMes = (ano: number, mes: number): [string, string] => {
  const doisDigitos = (n: number) => String(n).padStart(2, "0");
  const ultimo = new Date(ano, mes, 0).getDate();
  return [`${ano}-${doisDigitos(mes)}-01`, `${ano}-${doisDigitos(mes)}-${ultimo}`];
};

export const variacao = (atual: number, anterior: number): number | null => {
  if (anterior === 0) return null;
  return Math.round(((atual - anterior) / anterior) * 100);
};
